import { inject } from 'aurelia-framework';
import { DaiatariService } from 'pages/daiatari/service';

import 'pages/daiatari/report/html-report/styles.scss';

@inject(DaiatariService)
export class DaiatariHtmlReport {
    constructor(daiatariService) {
        this.daiatariService = daiatariService;
    }

    async activate() {
        this.reportSettings = JSON.parse(window.localStorage.getItem('daiatary_report_settings'));
        const reportDaiatariIds = JSON.parse(window.localStorage.getItem('daiatary_report_daiatariIds'));
        this.reportData = await this.daiatariService.generateHTMLReport(this.reportSettings, reportDaiatariIds);

        this.totals = {
            rawMaterialNetPrice: this.reportData.reduce((a, b) => a + b.rawMaterialNetPrice, 0).toFixed(4),
            rawMaterialVariance: this.reportData.reduce((a, b) => a + b.rawMaterialVariance, 0).toFixed(4),
            welding: this.reportData.reduce((a, b) => a + b.welding, 0).toFixed(4),
            stamping: this.reportData.reduce((a, b) => a + b.stamping, 0).toFixed(4),
            other: this.reportData.reduce((a, b) => a + b.other, 0).toFixed(4),
            purchasePrice: this.reportData.reduce((a, b) => a + b.purchasePrice, 0).toFixed(4),
            sga: this.reportData.reduce((a, b) => a + b.sga, 0).toFixed(4),
            profit: this.reportData.reduce((a, b) => a + b.profit, 0).toFixed(4),
            freightAllowance: this.reportData.reduce((a, b) => a + b.freightAllowance, 0).toFixed(4),
            packageAllowance: this.reportData.reduce((a, b) => a + b.packageAllowance, 0).toFixed(4),
            otherAllowance: this.reportData.reduce((a, b) => a + b.otherAllowance, 0).toFixed(4),
            total: this.reportData.reduce((a, b) => a + b.total, 0).toFixed(4),
        }
    }
}